<template>
    <AfValidationProvider v-slot="v"
                          :vid="vidComputed"
                          :disable-validation="disableValidation"
                          :name="labelComputed || ' '"
                          :rules="rules">
        <div class="form-floating float-select">
            <af-select
                class="form-control"
                :id="inputId"
                :name="inputName"
                v-bind="$attrs"
                v-on="xListeners(['input'])"
                :placeholder="placeholder"
                :options="options"
                :disabled="disabled"
                :loadOptions="loadOptions"
                :defaultOptions="defaultOptions"
                v-model="localValue"
                :state="getValidationState(v)">
                <slot v-for="(_, name) in $slots" :name="name" :slot="name"/>
                <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
                    <slot :name="name" v-bind="slotData"/>
                </template>
            </af-select>
            <label :for="inputId" v-text="labelComputed"></label>
            <b-form-invalid-feedback :id="inputId+'-live-feedback'">{{ v.errors[0] }}</b-form-invalid-feedback>
            <small v-if="tip" :id="inputId+'data-help'" class="form-text text-muted">{{ tip }}</small>
            <div class="form-floating__spinner">
                <b-spinner v-if="busy" type="border" label="Loading..."></b-spinner>
            </div>
        </div>
    </AfValidationProvider>
</template>

<script>

import input from "@/components/inputs/mixins/input";
import AfSelect from "@/components/inputs/AfSelect";
import xListeners from "@/mixins/xListeners";

export default {
    name: "FloatSelect",
    mixins: [input, xListeners],
    components: {AfSelect},
    props: ['options', 'loadOptions', 'defaultOptions', 'disabled'],
    methods: {
        stateClass(v) {
            let state = this.getValidationState(v)
            return state === true ? 'is-valid' : state === false ? 'is-invalid' : ''
        }
    },
}
</script>

<style lang="scss">

@import "@sass/vue-component";

.float-select {
    .form-control.af-select {
        border: 0;
        padding: 0;
    }

    .vue-treeselect__control {
        min-height: 100%;
        padding-top: 1.125rem !important;
    }

}


</style>
